<template>
  <div class="m-app">
    <a href="#main" class="skip-link">Zum Inhalt springen</a>
    <AppHeader />
    <main id="main" class="m-main" tabindex="-1">
      <slot />
    </main>
    <AppFooter />
  </div>
</template>

<script setup lang="ts">
// Default Layout für normale Website-Seiten
</script>

<style scoped>
.m-app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--m-bg);
}
.m-main {
  flex: 1;
}
.m-main:focus {
  outline: none;
}

/* Skip-to-content (WCAG 2.4.1): unsichtbar bis fokussiert. */
.skip-link {
  position: absolute;
  left: 8px;
  top: -48px;
  z-index: 2000;
  padding: 10px 16px;
  background: var(--m-primary, #2c3e50);
  color: #fff;
  border-radius: 0 0 8px 8px;
  font-weight: 600;
  text-decoration: none;
  transition: top 0.15s ease;
}
.skip-link:focus {
  top: 0;
  outline: 2px solid #fff;
  outline-offset: 2px;
}
</style>
